import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 48px;
  height: 48px;
  color: #1a56db;
`

const CodeEditor = ({ title = 'Code Tag', ...rest }: IconProps) => {
  return (
    <StyledIcon viewBox="0 0 48 48" title={title} {...rest}>
      <g id="Builder/-Operation/-Code-Editor" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="code" transform="translate(2.000000, 6.000000)" fill="currentColor" fillRule="nonzero">
          <path
            d="M9.99975,29.2517892 L0.58575,19.8377892 C-0.19525,19.0567892 -0.19525,17.7907892 0.58575,17.0097892 L9.99975,7.5957892 L12.82875,10.4237892 L4.82875,18.4237892 L12.82875,26.4237892 L9.99975,29.2517892 Z"
            id="Path"
          ></path>
          <path
            d="M33.99975,29.2517892 L31.17075,26.4237892 L39.17075,18.4237892 L31.17075,10.4237892 L33.99975,7.5957892 L43.41375,17.0097892 C44.19475,17.7907892 44.19475,19.0567892 43.41375,19.8377892 L33.99975,29.2517892 Z"
            id="Path"
          ></path>
          <rect
            id="Rectangle"
            transform="translate(21.999929, 18.424974) rotate(-75.954029) translate(-21.999929, -18.424974) "
            x="3.50745361"
            y="16.424977"
            width="36.9849501"
            height="3.9999946"
          ></rect>
        </g>
      </g>
    </StyledIcon>
  )
}

CodeEditor.displayName = 'CodeEditor'
CodeEditor.needsWork = true
export default CodeEditor
